import SliderViewSection from "../../components/SliderViewSection";
import {
    ContractorSlideImg,
    Contractor1,
    Contractor2,
    Contractor3,
    Contractor4,
    Contractor5,
    Contractor6,
    Component56,
    Component57,
    Component58,
    Component59,
    Component60,
    Component55,

} from "../../constant";
import ContactUs from "../../components/ContactUs";
import StayInLoop from "../../components/StayInLoop";
import SolutionFourCardSwapSection from "../../components/SolutionFourCardSwapSection";
import WeAreIED from "../../components/WeAreIED";
import HeroAboutVideo from "../../components/HeroAboutVideo";
import GraphViewSection from "../../components/GraphViewSection";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutline";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import ContractorManagementLanding from "../../components/Solution/ContractorManagementLanding";
import TogetherSection from "../../components/Solution/TogetherChange";

const slidesData = [

    {
        viewData: [{
            imgUrl: [Component55],
        },
        {
            imgUrl: [Component56],
        },
        {
            imgUrl: [Component57],
        },
        {
            imgUrl: [Component58],
        },
        {
            imgUrl: [Component60],
        },
        {
            imgUrl: [Component59],
        },
        
        ],










        menuItems: [{
            title: "Safety Compliance",
            Icons: HomeOutlinedIcon,
        },
        {
            title: "CPI & SPI Analysis",
            Icons: PeopleOutlineOutlinedIcon,
        },
        {
            title: "Permit Management",
            Icons: DashboardOutlinedIcon,
        },
        {
            title: "Score Cards ",
            Icons: HomeOutlinedIcon,
        },
        {
            title: "Productivity Monitoring",
            Icons: PeopleOutlineOutlinedIcon,
        },
        {
            title: "Task Monitoring",
            Icons: InsertChartOutlinedIcon,
        }
        ],
    }


];

const SliderData = [
    {
        title: "Contractor Performance Analytics",
        para: "Track contractor efficiency, workforce utilization and operational outcomes through intelligent dashboards.",
        mediaUrl: Contractor1
    },
    {
        title: "Hindrance Intelligence",
        para: "Detect operational constraints and contractor inefficiencies through AI-driven analytics.",
        mediaUrl: Contractor2
    },
    {
        title: "Compliance Intelligence",
        para: "Improve contractor governance with proactive compliance and safety monitoring.",
        mediaUrl: Contractor3
    },
    {
        title: "Operational Efficiency Tracking",
        para: "Enable data-driven contractor productivity management through intelligent operational analytics.",
        mediaUrl: Contractor4
    },
    {
        title: "Commercial Performance Visibility",
        para: "Strengthen contractor accountability with integrated financial and operational monitoring.",
        mediaUrl: Contractor5
    },
    {
        title: "Enterprise Contractor Intelligence",
        para: "Transform contractor oversight with connected performance, compliance and operational intelligence.",
        mediaUrl: Contractor6
    }
];

const FourCardsSwapcardData = [
    {
        title: "Unified Contractor Visibility",
        description:
            "Powered by connected workforce analytics and intelligent operational monitoring",
    },
    {
        title: "Improved Accountability & Compliance",
        description:
            "Strengthen contractor accountability with transparent performance evaluation systems",
    },

    {
        title: "Data-Driven Decision Intelligence",
        description:
            "Enable proactive contractor management through intelligent analytics and reporting",
    },
];
const tabsData = [
    {
        label: "About iED",
        key: "1",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Mission",
        key: "2",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Leadership",
        key: "3",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Differentiators",
        key: "4",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Technology",
        key: "5",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
];


export default function SolutionContractorManagement() {
    return (
        <>
            <ContractorManagementLanding />
            <SliderViewSection
                title={"Smart Solutions for Contractor Excellence"}
                subTitle={"Our dashboard offers powerful tools like hindrance analytics, production tracking, and performance scorecards. Streamline operations, improve efficiency, and make informed decisions with ease"}
                data={SliderData}
            />
            <SolutionFourCardSwapSection
                title={"Unlock Intelligent Contractor Performance Management"}
                subTitle={"Gain real-time visibility into contractor operations, improve accountability and drive operational efficiency through centralized dashboards and data-driven contractor intelligence. Enable smarter contractor governance with integrated performance tracking, workforce analytics and actionable insights that support faster decisions and transparent operational oversight. "}
                cardData={FourCardsSwapcardData}
            />
            <GraphViewSection
                title={"Precision and Visibility Across Every Parameter."}
                subTitle={"Our intelligent dashboards deliver a unified operational view across contractor performance, safety compliance, workforce readiness and infrastructure health — enabling organizations to monitor critical operational indicators in real time.Track compliance scores, equipment conditions, workforce certifications and environmental readiness through interactive analytics that support faster decisions and stronger governance across industrial operations."}
                data={slidesData}
            />
            <WeAreIED />
            <HeroAboutVideo tabsData={tabsData} isNetzero={true} />
            <TogetherSection
                title={"Building High-Performance Contractor Ecosystems"}
                subTitle={"Enable smarter contractor governance with connected digital solutions that improve workforce visibility, compliance tracking, and operational accountability. From onboarding to performance evaluation, our platforms help organizations monitor contractor productivity, safety adherence, and execution efficiency in real time. Drive transparency across contractor operations with data-driven insights, automated workflows, and centralized performance dashboards designed to enhance decision-making, reduce operational risks, and improve project outcomes at scale"}
            />
            <ContactUs />
            <StayInLoop />
        </>
    );
}
